import React, { useEffect, useState } from "react";
import { Button, Modal, Select, Form, Popconfirm, Checkbox } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useAddFaq, useUpdateFaqDetails } from "../../../hooks/userFAQ";
import { useFaqModules } from "../../../hooks/useFaqModules";

import {
  Messages,
  Notify,
  openNotification,
  RichTextEditor,
  util
} from '@seims/shared';

const FAQDetails = (props) => {

  const { visible, type, record, showModal, setHasUpdated } = props;

  const { data: modules = [], isFetching: modulesLoading } = useFaqModules();

  const [faqTitle, setFaqTitle] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [form] = Form.useForm();
  const { Option } = Select;
  const isAdd = type === "add";

  // Mutations
  const addFaqMutation = useAddFaq();
  const updateFaqMutation = useUpdateFaqDetails();

  // --------------------------------------
  // Load and initialize form
  // --------------------------------------
  useEffect(() => {
    setFaqTitle(isAdd ? "Add FAQ" : "Edit FAQ");
  }, [type]);

  // Re-run form initialization when record changes
  useEffect(() => {

    if (!visible) return;
    if (!record) return;

    // Required: wait until modules have been fetched
    if (modules.length === 0) return;

    initializeForm();
  }, [visible, record, modules]);

  // Initialize form + reset dirty tracking
  const initializeForm = () => {
    if (!record) return;

    const mod = modules.find(
      (m) => m.value?.toLowerCase().trim() === record.targetModule?.toLowerCase().trim()
    );

    form.setFieldsValue({
      id: record.id,
      targetModule: mod ? mod.key : undefined,
      question: record.question,
      answer: record.answer,
      confidencial: record.confidencial,
      archived: record.archived,
    });
  };

  // --------------------------------------
  // Handle Save
  // --------------------------------------
  const onSubmit = async (values) => {
    const entity = "FAQ";
    const isEdit = !isAdd && record?.id;

    if (isEdit) values.id = record.id;

    try {
      if (isAdd) {
        await addFaqMutation.mutateAsync(values);
      } else {
        await updateFaqMutation.mutateAsync(values);
      }

      form.resetFields();
      showModal({}, type, false);
      setHasUpdated(true);
    } catch (error) {
      console.error("FAQ Save Error:", error);
      openNotification(
        isAdd ? "Create FAQ" : "Update FAQ",
        util.parseMessage(
          isAdd ? Messages.ADD_FAILURE : Messages.UPDATE_FAILURE,
          entity
        ),
        Notify.ERROR
      );
    }
  };


  const handleCancel = () => {
    const isDirty = form.isFieldsTouched(true);

    if (isDirty) {
      setConfirmOpen(true);
    } else {
      form.resetFields();
      showModal({}, type, false);
    }
  };

  const confirmCancel = () => {
    form.resetFields();
    setConfirmOpen(false);
    showModal({}, type, false);
  };

  return (
    <Modal
      forceRender
      title={faqTitle}
      open={props.visible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      width={1000}
      footer={[
        <div className="modal-footer-buttons">
          <Button
            key="save"
            type="primary"
            htmlType="submit"
            form="FAQForm"
            loading={addFaqMutation.isLoading || updateFaqMutation.isLoading}
          >
            Save
          </Button>,

          <Popconfirm
            key="cancel-confirm"
            title="Are you sure you want to cancel? You will lose all entered information."
            okText="Yes"
            cancelText="No"
            open={confirmOpen}
            onConfirm={confirmCancel}
            onCancel={() => setConfirmOpen(false)}
          >
            <Button key="cancel" style={{ marginLeft: '10px' }} onClick={handleCancel}>
              Cancel
            </Button>
          </Popconfirm>,
        </div>,
      ]}
    >
      <Form
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 18,
        }}

        form={form}
        name="FAQForm"
        onFinish={onSubmit}

      >
        <Form.Item
          name="targetModule"
          label="Target Module"
          rules={[
            {
              required: true,
              message: "Please select target module",
            },
          ]}
        >

          <Select placeholder="Select target module" allowClear>
            {modules.map((module) => (
              <Option key={module.key} value={module.key}>
                {module.value}
              </Option>
            ))}
          </Select>

        </Form.Item>
        <Form.Item
          name="question"
          label="Question"
          rules={[
            {
              required: true,
              message: "Please provide a valid question"
            },
          ]}
        >
          <TextArea rows={3} />
        </Form.Item>

        <Form.Item
          name="answer"
          label="Answer"
          rules={[
            {
              required: true,
              message: "Please provide a valid answer"
            },
          ]}
        >

          <RichTextEditor placeholder={'Please provide valid answer here...'} />
        </Form.Item>
        <Form.Item
          label=""

        >
        </Form.Item>
        <Form.Item
          name="confidencial"
          label="Confidential"
          valuePropName="checked"

        >
          <Checkbox />

        </Form.Item>
        <Form.Item
          // hidden={true}
          name="archived"
          label="Archived"
          valuePropName="checked"

        >
          <Checkbox />

        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FAQDetails;
